export const RISK_TIERS = [
	{ value: 'OPTIMAL', label: 'Optimal', color: '#2ecc71' },
	{ value: 'RISKY', label: 'Risky', color: '#f1c40f' },
	{ value: 'HIGH_RISK', label: 'High Risk', color: '#e74c3c' }
];

export const SPORTS = [
	{ id: 1, name: 'nfl', label: 'NFL' },
	{ id: 2, name: 'nba', label: 'NBA' },
	{ id: 5, name: 'cfb', label: 'CFB' },
	{ id: 3, name: 'soccer', label: 'Soccer' },
	{ id: 4, name: 'cricket', label: 'Cricket' }
];

export const riskLabel = (value) =>
	RISK_TIERS.find((r) => r.value === value)?.label || value;
